import { render, staticRenderFns } from "./AuthCallbackPage.vue?vue&type=template&id=0b9df639&scoped=true"
import script from "./AuthCallbackPage.vue?vue&type=script&lang=js"
export * from "./AuthCallbackPage.vue?vue&type=script&lang=js"
import style0 from "./AuthCallbackPage.vue?vue&type=style&index=0&id=0b9df639&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9df639",
  null
  
)

export default component.exports